import React from "react";
import PropTypes from "prop-types";

import ErrorMessage from "components/errorMessage/errorMessage";
import Label from "components/label/label";

import styles from "./browseFileUpload.scss";

const BrowseFileUpload = (props) => {
  const {
    inputRef,
    name,
    label,
    value,
    required,
    touched,
    onChange,
    onBlur,
    helpTexts,
    fileUploadContainerClass,
    fileUploadClass,
    errors,
    showAllErrors,
    errorClass,
    invalidFieldClass,
    sampleFileMetaData,
    ...optionalProps
  } = props;

  const onUpload = (files) => {
    if (files && files.length > 0) {
      onChange(files);
    }
  };

  const onRemove = () => {
    inputRef.current.value = "";
    onChange("");
  };

  const getLabel = () => {
    if (value && value.length > 0) {
      return value[0].name;
    } else {
      return required ? label : `${label} (optional)`;
    }
  };

  const renderHelpTexts = () => {
    if (helpTexts && helpTexts.length > 0) {
      return (
        <div className={styles.uploadInstruction}>
          {helpTexts.map((helpText, index) => (
            <p className={styles.helpText} key={index}>
              <span className={styles.bullet}>*</span>
              {helpText}
            </p>
          ))}
        </div>
      );
    } else {
      return null;
    }
  };

  const renderSampleFile = () => {
    if (sampleFileMetaData) {
      const { text, link } = sampleFileMetaData;
      return (
        <div className={styles.sampleFileDownload}>
          <p className={styles.sampleFileText}>
            {text}
            <a className={styles.link} href={link} download="sample.xlsx">
              sample file.
            </a>
          </p>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div className={fileUploadContainerClass}>
      <ErrorMessage
        {...{ errors, showAllErrors, errorClass, invalidFieldClass }}
        isErrorVisible={touched}
        renderChildren={(invalidFieldClass) => (
          <React.Fragment>
            {renderSampleFile()}
            <div className={styles.customFileUploadPlaceholder}>
              <input
                {...optionalProps}
                ref={inputRef}
                type="file"
                id={name}
                required={required}
                onClick={(e) => {
                  e.target.value = "";
                }}
                onChange={(e) => onUpload(e.target.files)}
                onBlur={onBlur}
                files={value}
                className={`${fileUploadClass} `}
              />
              {label && <Label labelName={getLabel()} labelClass={`${styles.customFileUploadLabel} ${invalidFieldClass} `} />}
              {value && Object.keys(value).length > 0 ? (
                <span className={`material-icons ${styles.icon} ${styles.closeIcon}`} onClick={onRemove}>
                  close
                </span>
              ) : (
                <span className={`material-icons ${styles.icon}`}>vertical_align_top</span>
              )}
            </div>
            {renderHelpTexts()}
          </React.Fragment>
        )}
      />
    </div>
  );
};

BrowseFileUpload.defaultProps = {
  required: false,
  fileUploadClass: `${styles.customFileUploadInput} ${styles.inputControl}`,
  fileUploadContainerClass: styles.customFileUpload,
  invalidFieldClass: styles.error,
};

export default BrowseFileUpload;
